import React, { useCallback } from 'react'

import { getDispensaryTestKitRequestToastActions } from '../../../components/dispensaries/test-kit-request/DispensaryTestKitRequestToastActions'
import { useUniqueToast } from '../../toasts/hooks/useUniqueToast'

export interface ToastOptions {
  persist?: boolean
  message?: string | React.ReactNode
}

export interface UseDispensaryTestKitRequestToast {
  showSuccessToast: (options?: ToastOptions) => void
  showErrorToast: (options?: ToastOptions) => void
}

export const useDispensaryTestKitRequestToast = (): UseDispensaryTestKitRequestToast => {
  const { showToast, hideToastById } = useUniqueToast({
    toastIdPrefix: 'request-testkit-',
  })

  const showSuccessToast = useCallback(
    ({ persist = false, message }: ToastOptions = {}) => {
      showToast(message, {
        variant: 'success',
        action: getDispensaryTestKitRequestToastActions({
          dismissToast: hideToastById,
        }),
        persist,
      })
    },
    [hideToastById, showToast],
  )

  const showErrorToast = useCallback(
    ({ persist = false, message: customMessage }: ToastOptions = {}) => {
      const message = customMessage ?? 'There has been an unexpected error'
      showToast(message, {
        variant: 'error',
        action: getDispensaryTestKitRequestToastActions({ dismissToast: hideToastById }),
        persist,
      })
    },
    [hideToastById, showToast],
  )

  return { showSuccessToast, showErrorToast }
}
